/**
 * 공통헤더에 노출되는 버튼 컴포넌트 (뒤로가기, 마이, 장바구니, 최근 본 상품, 찜 등등)
 * - 각 페이지 레이아웃에서 조합해서 사용한다
 */

import { Header, HeaderActionProps } from '@yanolja-org/core-ui'
import { CartAction } from '@yanolja-org/core-ui-adapter'
import { BrandLogo } from '@yanolja-rnd/nol-design-system'
import {
  IcArrowback,
  IcClockH18,
  IcClose,
  IcFavoriteH18,
  IcHome,
  IcMyH18,
} from '@yanolja-rnd/nol-icons'
import { useNavigation } from '~/app/utils/use-navigation'

/** 모바일 > 뒤로가기 */
export const BackButton = ({ meta, onClick }: Pick<HeaderActionProps, 'meta' | 'onClick'>) => {
  const { onBackClick } = useNavigation()
  return (
    <Header.Action
      action="back"
      icon={<IcArrowback />}
      variant="icon"
      visibleOn="mobile"
      label="뒤로가기"
      meta={meta}
      onClick={e => {
        onClick?.(e)
        if (!e.defaultPrevented) {
          onBackClick()
        }
      }}
    />
  )
}

/** 모바일 > 닫기 */
export const CloseButton = ({ meta, onClick }: Pick<HeaderActionProps, 'meta' | 'onClick'>) => {
  return (
    <Header.Action
      action="close"
      icon={<IcClose />}
      variant="icon"
      visibleOn="mobile"
      label="닫기"
      meta={meta}
      onClick={onClick}
    />
  )
}

/** 모바일 > 홈 */
export const HomeButton = ({ meta, onClick }: Pick<HeaderActionProps, 'meta' | 'onClick'>) => {
  const { onHomeClick } = useNavigation()
  return (
    <Header.Action
      action="home"
      icon={<IcHome />}
      variant="icon"
      visibleOn="mobile"
      label="홈"
      meta={meta}
      onClick={e => {
        onClick?.(e)
        if (!e.defaultPrevented) {
          onHomeClick()
        }
      }}
    />
  )
}

/** NOL 로고 */
export const LogoButton = ({
  visibleOn,
  meta,
  onClick,
}: Pick<HeaderActionProps, 'meta' | 'visibleOn' | 'onClick'>) => {
  const { onHomeClick } = useNavigation()
  return (
    <Header.Logo
      visibleOn={visibleOn}
      action="logo"
      logo={<BrandLogo />}
      meta={meta}
      onClick={e => {
        onClick?.(e)
        if (!e.defaultPrevented) {
          onHomeClick()
        }
      }}
    />
  )
}

/** 마이페이지 */
export const MyPageButton = ({ meta }: Pick<HeaderActionProps, 'meta'>) => {
  const { onMyPageClick } = useNavigation()
  return (
    <Header.Action
      action="my"
      icon={<IcMyH18 />}
      label="마이"
      meta={meta}
      onClick={onMyPageClick}
    />
  )
}

/** 찜 */
export const WishButton = ({ meta }: Pick<HeaderActionProps, 'meta'>) => {
  const { onWishlistClick } = useNavigation()
  return (
    <Header.Action
      action="wish"
      icon={<IcFavoriteH18 />}
      label="찜"
      meta={meta}
      onClick={onWishlistClick}
    />
  )
}

/**
 * 장바구니 — core-ui-adapter preset 사용 (기본/active 아이콘 내장).
 * active=true 면 현재 지면이 장바구니 (filled 아이콘 + bold 라벨).
 * 앱(웹뷰)/현재 페이지 새로고침 분기는 onCartClick 이 수행하므로
 * preventDefault 로 preset 의 anchor 기본 이동을 막는다.
 */
export const CartButton = ({ meta, active }: Pick<HeaderActionProps, 'meta' | 'active'>) => {
  const { onCartClick } = useNavigation()
  return (
    <CartAction
      active={active}
      meta={meta}
      onClick={e => {
        e.preventDefault()
        onCartClick()
      }}
    />
  )
}

/** 최근 본 상품 */
export const RecentProductButton = ({ meta }: Pick<HeaderActionProps, 'meta'>) => {
  const { onRecentProductClick } = useNavigation()
  return (
    <Header.Action
      action="recent"
      icon={<IcClockH18 />}
      label="최근 본 상품"
      meta={meta}
      onClick={onRecentProductClick}
    />
  )
}
